'use client';

// As of February 2024, requestIdleCallback is not supported in Safari on
// macOS, iOS, or iPadOS. According to caniuse.com, it is now supported in the
// Technical Preview of Safari so we may not require this polyfill in future,
// but even if it is added to the stable version of Safari in 2024 then to
// support users with older browsers it will probably be necessary to include
// this polyfill until at least 2028.

if (typeof window !== 'undefined') {
  window.requestIdleCallback =
    window.requestIdleCallback ||
    (callbackToRun => setTimeout(callbackToRun, 0));

  // TODO: Once GTM has been updated to include a copy of this function when
  // required, it should be deleted from here
  const lazyLoadScript = (src, attributes = {}) => {
    const {
      async = true,
      defer = true,
      crossorigin = 'anonymous',
      id,
      ...otherAttributes
    } = attributes;

    window.addEventListener('load', function() {
      window.requestIdleCallback(() => {
        if (id && document.getElementById(id)) {
          // If the script has already been loaded, do nothing
          return;
        }

        const node = document.createElement('script');
        node.type = 'text/javascript';

        node.src = src;
        node.async = async;
        node.defer = defer;
        node.crossorigin = crossorigin;
        node.id = id;

        Object.entries(otherAttributes).forEach(([key, value]) => {
          node.setAttribute(key, value);
        });

        const firstScript = document.getElementsByTagName('script')[0];
        firstScript.parentNode.insertBefore(node, firstScript);
      });
    });
  };

  window.lazyLoadScript = lazyLoadScript;
}

// This is a dummy component that is used to load any client-side polyfills
const LoadClientPolyfills = () => null;

export default LoadClientPolyfills;
